<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    v-bind="menuProps"
    min-width="auto"
  >
    <template v-slot:activator="{ on }">
      <v-chip small v-on="on" slot="activator">Custom</v-chip>
    </template>

    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <v-color-picker
              light
              flat
              :hide-mode-switch="true"
              mode="hexa"
              hide_inputs
              :show-swatches="false"
              v-model="inputValue"
              class="ma-2"
            ></v-color-picker>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>


<script>
export default {
  props: {
    // Take start and end as the input. Passable via v-model.
    value: [String, Object],
    inputProps: Object,
    menuProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  watch: {
    // Watching to see if the menu is closed.
    menu(isOpen) {
      if (!isOpen) {
        this.closeMenu();
      }
    },
    value(n) {
      this.inputValue = n ? n.substr(0, 7) : "";
    },
    inputValue(value) {
      this.$emit("input", value);
    },
  },
  data() {
    return {
      menu: false,
      inputValue: this.value ? this.value.substr(0, 7) : `#FF00FF`,
      showPicker: false,
    };
  },

  computed: {
    valueOut() {
      return this.inputValue;
    },

    previewColor() {
      return (
        "border-radius:5px;width:40px;height:30px;background-color:" +
        this.inputValue
      );
    },
  },

  methods: {
    closeMenu() {
      this.$emit("menu-closed");
      setTimeout(() => {
        this.showPicker = false;
      }, 250);
    },
  },
};
</script>
